import { useQuery } from '@tanstack/react-query';
import { trackersAPI } from '@/lib/trackers-api';
import { queryKeys } from '@/lib/query-keys';
import type { TrackerSearchParams } from '@/types';

export const useTrackers = (params?: TrackerSearchParams) => {
  return useQuery({
    queryKey: queryKeys.consultation.catalogs.trackers(params),
    queryFn: () => trackersAPI.list(params),
  });
};

